import le from './le.js';

/**
 * Lt.
 *
 * @param {number} n
 * @param {Iterable} iterable
 */
const lt = (n, iterable) => le(n - 1, iterable);
export default lt;
